import { render, staticRenderFns } from "./SubDialog.vue?vue&type=template&id=560d26b2&scoped=true&"
import script from "./SubDialog.vue?vue&type=script&lang=js&"
export * from "./SubDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d26b2",
  null
  
)

export default component.exports